import { ICharge } from 'types';
import { StyledChargeListElement } from './styles';
import { formateDate, formateHashUnits, formateTime } from 'utils';
import { IAccrual } from 'types/accruals';
interface IChargeListElementProps extends IAccrual {
  children?: React.ReactNode;
}
export const ChargeListElement = ({ date, hashRate, amount, rate }: IChargeListElementProps) => {
  const elementDate = new Date(date);
  const formatedDate = formateDate(elementDate);
  const formatedTime = formateTime(elementDate);

  return (
    <StyledChargeListElement>
      <div className="charges-list-element-col date-time">
        {formatedDate}
        {<span className="time">{`-${formatedTime}`}</span>}
      </div>
      <div className="charges-list-element-col hashrate">{formateHashUnits(hashRate)}</div>
      <div className="charges-list-element-col general-accruals">{Number(amount).toFixed(10)}</div>
      <div className="charges-list-element-col ">{Number(rate).toFixed(10)}</div>
    </StyledChargeListElement>
  );
};
